import { Companion } from '../types';

// PairUpToday — IQ200 Dynamic Location System
// Predefined hardcoded city arrays removed in compliance with Master Rule.
// Locations are dynamically retrieved and validated using Google Places API (New) with India restriction (IN).

export function getCoordinatesForCity(city: string): { latitude: number; longitude: number } {
  const norm = (city || '').toLowerCase().trim();
  if (norm.includes('new town') || norm.includes('rajarhat')) return { latitude: 22.5867, longitude: 88.4754 };
  if (norm.includes('salt lake') || norm.includes('bidhannagar')) return { latitude: 22.5815, longitude: 88.4172 };
  if (norm.includes('kolkata') || norm.includes('calcutta') || norm.includes('park street') || norm.includes('jadavpur') || norm.includes('ballygunge')) return { latitude: 22.5726, longitude: 88.3639 };
  if (norm.includes('howrah') || norm.includes('shibpur')) return { latitude: 22.5958, longitude: 88.2636 };
  if (norm.includes('bardhaman') || norm.includes('burdwan') || norm.includes('golapbag')) return { latitude: 23.2324, longitude: 87.8615 };
  if (norm.includes('durgapur')) return { latitude: 23.5204, longitude: 87.3119 };
  if (norm.includes('asansol')) return { latitude: 23.6739, longitude: 86.9524 };
  if (norm.includes('siliguri')) return { latitude: 26.7271, longitude: 88.3953 };
  if (norm.includes('darjeeling')) return { latitude: 27.0410, longitude: 88.2663 };
  if (norm.includes('digha')) return { latitude: 21.6266, longitude: 87.5074 };
  if (norm.includes('kharagpur')) return { latitude: 22.3460, longitude: 87.2320 };
  if (norm.includes('bolpur') || norm.includes('shantiniketan')) return { latitude: 23.6693, longitude: 87.6843 };
  if (norm.includes('mumbai') || norm.includes('bandra') || norm.includes('andheri')) return { latitude: 19.0760, longitude: 72.8777 };
  if (norm.includes('pune')) return { latitude: 18.5204, longitude: 73.8567 };
  if (norm.includes('delhi') || norm.includes('noida') || norm.includes('gurgaon') || norm.includes('gurugram')) return { latitude: 28.6139, longitude: 77.2090 };
  if (norm.includes('bengaluru') || norm.includes('bangalore')) return { latitude: 12.9716, longitude: 77.5946 };
  if (norm.includes('hyderabad')) return { latitude: 17.3850, longitude: 78.4867 };
  if (norm.includes('chennai')) return { latitude: 13.0827, longitude: 80.2707 };
  return { latitude: 22.5726, longitude: 88.3639 };
}

// Deprecated empty interfaces for backward compatibility
export interface FlatCityItem {
  city: string;
  state: string;
  displayName: string;
}
export const STATE_CITIES_MAP: Record<string, string[]> = {};
export const ALL_CITIES_FLAT: FlatCityItem[] = [];

export const COMPANIONS_DATA: Companion[] = [
  // ==================== WEST BENGAL (Kolkata, Bardhaman, Durgapur, Siliguri, Asansol, Howrah) ====================
  {
    id: 'riya-sharma',
    name: 'Riya Sharma',
    age: 24,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.95,
    reviewsCount: 128,
    city: 'Kolkata',
    state: 'West Bengal',
    coverageCities: ['Kolkata', 'Howrah', 'Bardhaman', 'Durgapur', 'Kalyani'],
    hourlyRate: 999,
    image: 'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Art lover, book enthusiast & cheerful Bengali companion. Perfect for family dinners, weddings & cafe dates.',
    about: 'Creative content designer and literature graduate from Jadavpur University. Whether you need a warm, polite date for a friend’s wedding, a charming companion for art galleries, or someone for relaxed cafe conversations on Park Street, I ensure a respectful and memorable time.',
    height: "5'5\"",
    languages: ['Bengali', 'English', 'Hindi'],
    education: 'B.A. in English Literature (Jadavpur University)',
    profession: 'Creative Designer & Content Lead',
    interests: ['Contemporary Art', 'Park Street Cafes', 'Acoustic Music', 'Photography', 'Travel'],
    supportedOccasions: ['Wedding Guest', 'Family Dinners', 'Art & Cultural Events', 'Coffee Dates', 'City Walking Tours'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'priya-mukherjee-bardhaman',
    name: 'Priya Mukherjee',
    age: 23,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.96,
    reviewsCount: 114,
    city: 'Bardhaman',
    state: 'West Bengal',
    coverageCities: ['Bardhaman', 'Durgapur', 'Asansol', 'Kolkata', 'Bolpur', 'Ranaghat'],
    hourlyRate: 899,
    image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Graceful Kathak dancer, literature graduate & warm companion for Bardhaman Rajbari walks, weddings & family dinners.',
    about: 'Literature graduate from Burdwan University (Golapbag Campus). Born and brought up in Bardhaman. Very courteous, soft-spoken, and respectful. Available for wedding receptions, family functions, Curzon Gate cafe meets, and heritage trips across Bardhaman and nearby towns.',
    height: "5'4\"",
    languages: ['Bengali', 'English', 'Hindi'],
    education: 'M.A. in Bengali Literature (Burdwan University)',
    profession: 'Cultural Researcher & Kathak Vocalist',
    interests: ['Bardhaman Mihiduri & Sitabhog Trails', 'Kathak Dance', 'Tagore Songs', 'Rajbari Architecture', 'Photography'],
    supportedOccasions: ['Bengali Weddings', 'Boubhat & Annaprasan', 'Family Dinners', 'Heritage Walks', 'Cafe Dates'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'abhik-roy-bardhaman',
    name: 'Abhik Roy',
    age: 26,
    gender: 'male',
    isVerified: true,
    isAvailable: true,
    rating: 4.93,
    reviewsCount: 98,
    city: 'Bardhaman',
    state: 'West Bengal',
    coverageCities: ['Bardhaman', 'Durgapur', 'Asansol', 'Kolkata', 'Bolpur'],
    hourlyRate: 1099,
    image: 'https://images.unsplash.com/photo-1618886614638-80e3c103d31a?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1618886614638-80e3c103d31a?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Software engineer, polite gentleman & badminton enthusiast from Bardhaman. Great plus-one for weddings & dinners.',
    about: 'Senior Frontend Engineer working remotely from Bardhaman. UIT Burdwan graduate. Punctual, chivalrous, well-dressed, and an engaging conversationalist for wedding plus-ones, casual dates, and family events.',
    height: "5'11\"",
    languages: ['Bengali', 'English', 'Hindi'],
    education: 'B.Tech in Computer Science (UIT, Burdwan University)',
    profession: 'Senior Software Engineer',
    interests: ['Badminton', 'Acoustic Guitar', 'Long Drives on NH19', 'Bardhaman History', 'Gourmet Food'],
    supportedOccasions: ['Wedding Plus-One', 'Family Dinners', 'Cafe Meets', 'Long Drives', 'Corporate Meetups'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'sneha-sen-durgapur',
    name: 'Sneha Sen',
    age: 24,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.97,
    reviewsCount: 132,
    city: 'Durgapur',
    state: 'West Bengal',
    coverageCities: ['Durgapur', 'Asansol', 'Bardhaman', 'Kolkata', 'Raniganj'],
    hourlyRate: 999,
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'NIT Durgapur alumna, tech analyst & charming conversationalist for Junction Mall dinners, weddings & cafe dates.',
    about: 'Data Analyst and proud alumna of NIT Durgapur, living near City Centre. Friendly, smart, polite, and great at making social evenings relaxed and memorable. Perfect companion for dining at Fortune Park, Junction Mall adda, and grand Bengali weddings.',
    height: "5'5\"",
    languages: ['Bengali', 'English', 'Hindi'],
    education: 'B.Tech & M.Tech (NIT Durgapur)',
    profession: 'Data Analytics Consultant',
    interests: ['City Centre Cafes', 'Classical Violin', 'Badminton', 'Bengali Cinema', 'Travel'],
    supportedOccasions: ['Grand Bengali Weddings', 'Junction Mall Dinners', 'Family Functions', 'Tech Meetups', 'Coffee Dates'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'anirban-ghosh-durgapur',
    name: 'Anirban Ghosh',
    age: 27,
    gender: 'male',
    isVerified: true,
    isAvailable: true,
    rating: 4.94,
    reviewsCount: 110,
    city: 'Durgapur',
    state: 'West Bengal',
    coverageCities: ['Durgapur', 'Asansol', 'Bardhaman', 'Bankura', 'Raniganj'],
    hourlyRate: 1199,
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Mechanical engineer at DSP, acoustic singer & polite companion for club dinners, weddings & drives.',
    about: 'Mechanical design specialist based in Steel Township, Durgapur. Well-educated, courteous, funny, and great at making anyone feel comfortable and respected at formal club dinners, family weddings, and drives around Maithon Dam.',
    height: "6'0\"",
    languages: ['Bengali', 'English', 'Hindi'],
    education: 'B.E. (Jadavpur University)',
    profession: 'Mechanical Engineer & Indie Musician',
    interests: ['Acoustic Guitar', 'Durgapur Club Evenings', 'Maithon Dam Roadtrips', 'Fine Dining', 'Cricket'],
    supportedOccasions: ['Family Weddings', 'Club Receptions', 'Casual Dinners', 'Road Trips', 'Concerts'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'pooja-das-siliguri',
    name: 'Pooja Das',
    age: 24,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.96,
    reviewsCount: 120,
    city: 'Siliguri',
    state: 'West Bengal',
    coverageCities: ['Siliguri', 'Darjeeling', 'Jalpaiguri', 'Kalimpong', 'Cooch Behar'],
    hourlyRate: 1050,
    image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Hospitality curator, Darjeeling tea connoisseur & cheerful companion for City Centre Siliguri & hills trips.',
    about: 'Hospitality management graduate from North Bengal University, living on Sevoke Road, Siliguri. Warm smile, cultured manners, and deep love for tea estates, Himalayan trips, and destination weddings.',
    height: "5'4\"",
    languages: ['Bengali', 'English', 'Hindi', 'Nepali (Basic)'],
    education: 'B.Sc in Hospitality & Tourism (NBU Siliguri)',
    profession: 'Boutique Resort Curator',
    interests: ['Darjeeling Tea Estates', 'City Centre Siliguri', 'Mountain Photography', 'Acoustic Music', 'Hiking'],
    supportedOccasions: ['Destination Hill Weddings', 'Sevoke Road Dinners', 'Tea Estate Tours', 'Family Meets', 'Cafe Dates'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'rohan-banerjee-siliguri',
    name: 'Rohan Banerjee',
    age: 26,
    gender: 'male',
    isVerified: true,
    isAvailable: true,
    rating: 4.93,
    reviewsCount: 94,
    city: 'Siliguri',
    state: 'West Bengal',
    coverageCities: ['Siliguri', 'Darjeeling', 'Kurseong', 'Jalpaiguri', 'Gangtok'],
    hourlyRate: 1150,
    image: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Adventure photographer, polite companion for Siliguri evenings, resort weddings & Darjeeling day trips.',
    about: 'Commercial photographer and cafe co-owner in Siliguri. Courteous, calm, respectful, and knows all the scenic viewpoints, heritage hotels, and cafes in North Bengal.',
    height: "6'0\"",
    languages: ['Bengali', 'English', 'Hindi'],
    education: 'B.A. in Media Arts & Communication',
    profession: 'Travel Photographer & Cafe Co-Founder',
    interests: ['Himalayan Photography', 'Specialty Coffee', 'Motorcycle Touring', 'Squash', 'Documentaries'],
    supportedOccasions: ['Resort Weddings', 'Mountain Day Trips', 'Fine Dining', 'Photography Walks', 'Family Gatherings'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'tathagata-chatterjee-asansol',
    name: 'Tathagata Chatterjee',
    age: 27,
    gender: 'male',
    isVerified: true,
    isAvailable: true,
    rating: 4.92,
    reviewsCount: 88,
    city: 'Asansol',
    state: 'West Bengal',
    coverageCities: ['Asansol', 'Durgapur', 'Raniganj', 'Bardhaman', 'Dhanbad'],
    hourlyRate: 1100,
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Mining engineer, acoustic guitarist & gentlemanly companion for Asansol club events & wedding banquets.',
    about: 'Mining Consultant from Burnpur / Asansol. St. Patrick’s School & IIT ISM Dhanbad alumnus. Polite, well-spoken, charismatic, and great for family ceremonies, corporate dinners, and casual cafe dates.',
    height: "5'11\"",
    languages: ['Bengali', 'English', 'Hindi'],
    education: 'B.Tech Mining Engineering (IIT ISM Dhanbad)',
    profession: 'Mining Consultant & Project Engineer',
    interests: ['Burnpur Club Tennis', 'Acoustic Rock', 'Kalyaneshwari Temple & Maithon', 'Gastronomy', 'Reading'],
    supportedOccasions: ['Bengali Weddings', 'Club Receptions', 'Maithon Picnics', 'Formal Dinners', 'Family Meets'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'sreya-chakraborty-howrah',
    name: 'Sreya Chakraborty',
    age: 24,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.95,
    reviewsCount: 116,
    city: 'Howrah',
    state: 'West Bengal',
    coverageCities: ['Howrah', 'Kolkata', 'Kalyani', 'Hooghly', 'Bardhaman'],
    hourlyRate: 950,
    image: 'https://images.unsplash.com/photo-1604904612715-47bf9d9bc670?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1604904612715-47bf9d9bc670?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Architect, heritage enthusiast from Shibpur & graceful plus-one for riverfront dinners, weddings & galas.',
    about: 'Architecture graduate from IIEST Shibpur, Howrah. Passionate about colonial river ghats, Botanic Garden walks, traditional sarees, and engaging, polite conversations at family banquets.',
    height: "5'4\"",
    languages: ['Bengali', 'English', 'Hindi'],
    education: 'B.Arch (IIEST Shibpur, Howrah)',
    profession: 'Urban Heritage Architect',
    interests: ['Hooghly Riverfront Walks', 'Botanic Garden', 'Baluchari Sarees', 'Rabindra Sangeet', 'Sketching'],
    supportedOccasions: ['Traditional Weddings', 'River Cruise Dinners', 'Botanical Walks', 'Boubhat Dinners', 'Coffee Dates'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'sagnik-bhattacharya',
    name: 'Sagnik Bhattacharya',
    age: 27,
    gender: 'male',
    isVerified: true,
    isAvailable: true,
    rating: 4.95,
    reviewsCount: 136,
    city: 'Kolkata',
    state: 'West Bengal',
    coverageCities: ['Kolkata', 'Howrah', 'Bardhaman', 'Durgapur', 'Siliguri'],
    hourlyRate: 1299,
    image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Warm Bengali gentleman, tech architect & acoustic musician. Ideal for family dinners, weddings & club meets.',
    about: 'Senior Cloud Consultant and part-time acoustic guitar artist from Salt Lake, Kolkata. An alumnus of Jadavpur University, I value respectful etiquette, stimulating conversations on music, cinema and books, and being a dependable plus-one for any social occasion.',
    height: "5'11\"",
    languages: ['Bengali', 'English', 'Hindi'],
    education: 'B.Tech (Jadavpur University) & M.Tech',
    profession: 'Cloud Solutions Architect & Musician',
    interests: ['Acoustic Guitar', 'Rabindra Sangeet Fusion', 'Coffee House Adda', 'North Kolkata Walks', 'Fine Dining'],
    supportedOccasions: ['Wedding Guest', 'Family Dinners', 'Live Concerts', 'Cultural Events', 'Fine Dining Dates'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'debjani-ganguly',
    name: 'Debjani Ganguly',
    age: 24,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.96,
    reviewsCount: 148,
    city: 'Kolkata',
    state: 'West Bengal',
    coverageCities: ['Kolkata', 'Howrah', 'Bardhaman', 'Durgapur', 'Bolpur'],
    hourlyRate: 1150,
    image: 'https://images.unsplash.com/photo-1616683693504-3ea7e9ad6fec?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1616683693504-3ea7e9ad6fec?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Graceful in sarees, warm listener & classical singer. Perfect plus-one for traditional Bengali weddings & events.',
    about: 'Master in Economics from Presidency University, currently working as a quantitative analyst in Newtown. I take pride in traditional Bengali elegance, courteous conversation, and making your family or social gatherings truly memorable and respectful.',
    height: "5'4\"",
    languages: ['Bengali', 'English', 'Hindi'],
    education: 'M.Sc in Economics (Presidency University, Kolkata)',
    profession: 'Quantitative Risk Analyst',
    interests: ['Jamdani & Baluchari Sarees', 'Rabindra Sangeet', 'Flurys High Tea', 'Art Galleries', 'Documentaries'],
    supportedOccasions: ['Bengali Weddings', 'Boubhat & Receptions', 'Family Get-togethers', 'Art Exhibitions', 'Coffee Dates'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'rohan-roy',
    name: 'Rohan Roy',
    age: 26,
    gender: 'male',
    isVerified: true,
    isAvailable: true,
    rating: 4.94,
    reviewsCount: 142,
    city: 'Kolkata',
    state: 'West Bengal',
    coverageCities: ['Kolkata', 'Howrah', 'Bardhaman', 'Durgapur', 'Siliguri'],
    hourlyRate: 1350,
    image: 'https://images.unsplash.com/photo-1628157582853-a796fa650a6a?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1628157582853-a796fa650a6a?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Charismatic commercial pilot & gentlemanly companion for Bengali weddings, receptions & romantic dinners.',
    about: 'Commercial airline pilot and lifestyle photographer living in New Town, Kolkata. Known for calm composure, chivalrous manners, storytelling from world travels, and making any social evening truly delightful and respectful.',
    height: "6'1\"",
    languages: ['Bengali', 'English', 'Hindi', 'French (Basic)'],
    education: 'Commercial Pilot License (DGCA) & B.Sc in Aviation',
    profession: 'Commercial Pilot & Travel Photographer',
    interests: ['Aviation', 'Heritage Photography', 'Acoustic Guitar', 'Fine Dining', 'Squash'],
    supportedOccasions: ['VIP Receptions & Galas', 'Destination Weddings', 'Romantic Rooftop Dinners', 'Travel & Weekend Trips', 'Family Meets'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'anwesha-sen',
    name: 'Anwesha Sen',
    age: 23,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.93,
    reviewsCount: 110,
    city: 'Kolkata',
    state: 'West Bengal',
    coverageCities: ['Kolkata', 'Howrah', 'Bardhaman', 'Kalyani', 'Bolpur'],
    hourlyRate: 1050,
    image: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Sweet smile, literature enthusiast & delightful companion for heritage walks, book fairs & reunions.',
    about: 'English literature graduate from Scottish Church College, Kolkata. Warm-hearted, respectful, and loves deep discussions on novels, indie theatre at Nandan, and relaxed adda over hot Darjeeling tea.',
    height: "5'3\"",
    languages: ['Bengali', 'English', 'Hindi'],
    education: 'M.A. in English (Scottish Church College)',
    profession: 'Editorial Specialist & Content Curator',
    interests: ['Kolkata Book Fair', 'Nandan Cinema', 'College Street Adda', 'Heritage Architecture', 'Poetry'],
    supportedOccasions: ['Book Fairs & Lit Fests', 'Heritage Walks', 'Reunions & Meetups', 'Coffee & Tea Dates', 'Family Functions'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'soumyadeep-dasgupta',
    name: 'Soumyadeep Dasgupta',
    age: 28,
    gender: 'male',
    isVerified: true,
    isAvailable: true,
    rating: 4.96,
    reviewsCount: 124,
    city: 'Kolkata',
    state: 'West Bengal',
    coverageCities: ['Kolkata', 'Howrah', 'Bardhaman', 'Durgapur', 'Asansol'],
    hourlyRate: 1399,
    image: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Sophisticated corporate lawyer & cultured plus-one for formal banquets, club dinners & high-profile weddings.',
    about: 'Senior Legal Associate at a top law firm in Kolkata. St. Xavier’s and NUJS alumnus. Eloquent, dignified, well-mannered, and adept at making high-stakes formal dinners and family celebrations flow effortlessly.',
    height: "6'0\"",
    languages: ['Bengali', 'English', 'Hindi'],
    education: 'B.A. LL.B. (NUJS Kolkata) & B.Com (St. Xavier’s)',
    profession: 'Corporate Legal Counsel',
    interests: ['Calcutta Club Evenings', 'Debating', 'Vintage Bengali Cinema', 'Tennis', 'Gastronomy'],
    supportedOccasions: ['Formal Banquets', 'Corporate Receptions', 'Traditional Bengali Weddings', 'Club Dinners', 'Family Meets'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },

  // ==================== MAHARASHTRA (Mumbai, Pune) ====================
  {
    id: 'arjun-verma',
    name: 'Arjun Verma',
    age: 26,
    gender: 'male',
    isVerified: true,
    isAvailable: true,
    rating: 4.92,
    reviewsCount: 116,
    city: 'Mumbai',
    state: 'Maharashtra',
    coverageCities: ['Mumbai', 'Thane', 'Navi Mumbai', 'Pune', 'Nashik'],
    hourlyRate: 1199,
    image: 'https://images.unsplash.com/photo-1480429370139-e0132c086e2a?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1480429370139-e0132c086e2a?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Polite, chivalrous gentleman with sharp style. Ideal companion for corporate galas, formal dinners & VIP events.',
    about: 'Digital strategy consultant working in Bandra, Mumbai. I enjoy formal dinners, high-energy networking events, cinema, and fitness activities. Always punctual, respectful, well-dressed in Indian/Western formals, and engaging in any setting.',
    height: "6'0\"",
    languages: ['Hindi', 'English', 'Marathi'],
    education: 'MBA in Marketing (NMIMS Mumbai)',
    profession: 'Digital Strategy Consultant',
    interests: ['Fitness & Gym', 'Fine Dining', 'Stand-up Comedy', 'Cinema', 'Tech Gadgets'],
    supportedOccasions: ['Corporate Dinners', 'Cocktail Parties', 'Friend Gatherings', 'Movies', 'Weekend Sightseeing'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'natasha-deshmukh',
    name: 'Natasha Deshmukh',
    age: 25,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.96,
    reviewsCount: 142,
    city: 'Mumbai',
    state: 'Maharashtra',
    coverageCities: ['Mumbai', 'Thane', 'Navi Mumbai', 'Pune', 'Goa'],
    hourlyRate: 1350,
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Creative director, cinephile & poised companion for film premieres, Marine Drive strolls & cocktail parties.',
    about: 'Creative Director at an advertising agency in Lower Parel, Mumbai. Graduated from Sophia College. Elegant, well-traveled, and loves conversations spanning indie cinema, contemporary art, rooftop dining, and fashion.',
    height: "5'6\"",
    languages: ['English', 'Hindi', 'Marathi', 'French (Basic)'],
    education: 'B.A. in Media & Mass Communication (Sophia College)',
    profession: 'Advertising Creative Director',
    interests: ['Film Premieres', 'Marine Drive Sunsets', 'Contemporary Art', 'Specialty Coffee', 'Jazz Music'],
    supportedOccasions: ['Cocktail Receptions', 'Film Festivals', 'Dinner Dates', 'Friend Gatherings', 'Weekend City Tours'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'tanvi-kulkarni',
    name: 'Tanvi Kulkarni',
    age: 24,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.93,
    reviewsCount: 108,
    city: 'Pune',
    state: 'Maharashtra',
    coverageCities: ['Pune', 'Mumbai', 'Nashik', 'Kolhapur'],
    hourlyRate: 1050,
    image: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Literature educator, classical singer & charming companion for Koregaon Park cafes & cultural fests.',
    about: 'Literature teacher and classical vocalist based in Koregaon Park, Pune. Graduated from Fergusson College. Warm, thoughtful, and loves sharing deep discussions on art, cinema, treks, and acoustic music.',
    height: "5'4\"",
    languages: ['Marathi', 'English', 'Hindi'],
    education: 'M.A. in English Literature (Fergusson College, Pune)',
    profession: 'Content Lead & Classical Vocalist',
    interests: ['Hindustani Classical', 'Koregaon Park Cafes', 'Western Ghat Treks', 'Theatre & Natak', 'French Cinema'],
    supportedOccasions: ['Music Festivals', 'Cafe Dates', 'Family Functions', 'Art Shows', 'Weekend Getaways'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },

  // ==================== DELHI NCR ====================
  {
    id: 'zoya-khan',
    name: 'Zoya Khan',
    age: 25,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.94,
    reviewsCount: 135,
    city: 'Delhi',
    state: 'Delhi NCR',
    coverageCities: ['New Delhi', 'Noida', 'Gurgaon', 'Faridabad', 'Ghaziabad', 'Jaipur'],
    hourlyRate: 1300,
    image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Glamorous, witty, luxury event host & charismatic companion for rooftop parties and destination weddings.',
    about: 'Public relations consultant and celebrity event host based in South Delhi. Exudes poise, impeccable ethnic/western styling, and energetic conversational flair at weddings, red carpets, and VIP receptions.',
    height: "5'7\"",
    languages: ['Hindi', 'English', 'Urdu'],
    education: 'Master in Mass Communication & Media (Jamia Millia)',
    profession: 'PR Manager & Celebrity Host',
    interests: ['Fashion Weeks', 'Rooftop Lounges', 'Theatre', 'Mughlai Culinary Arts', 'Travel'],
    supportedOccasions: ['Fashion Shows', 'Destination Weddings', 'Rooftop Parties', 'Film Premieres', 'VIP Receptions'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'rohan-malhotra',
    name: 'Rohan Malhotra',
    age: 27,
    gender: 'male',
    isVerified: true,
    isAvailable: true,
    rating: 4.93,
    reviewsCount: 104,
    city: 'Delhi',
    state: 'Delhi NCR',
    coverageCities: ['New Delhi', 'Gurgaon', 'Noida', 'Chandigarh', 'Jaipur'],
    hourlyRate: 1350,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Polite management consultant, avid golfer & charismatic plus-one for Delhi high-society events & weddings.',
    about: 'Strategy consultant at a global Big 4 firm in CyberCity, Gurgaon. Well-mannered, eloquent, and comfortable in royal Punjabi weddings, embassy balls, corporate dinners, and casual cafe dates.',
    height: "6'1\"",
    languages: ['Hindi', 'English', 'Punjabi'],
    education: 'MBA (FMS Delhi) & B.Tech (DTU)',
    profession: 'Senior Management Consultant',
    interests: ['Golf', 'Diplomatic Enclave Cafes', 'Sufi Music', 'Fine Dining', 'Cars & Autosports'],
    supportedOccasions: ['Destination Weddings', 'Embassy Receptions', 'Corporate Dinners', 'Golf Meets', 'Club Parties'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },

  // ==================== KARNATAKA (Bangalore) ====================
  {
    id: 'kabir-singh',
    name: 'Kabir Singh',
    age: 27,
    gender: 'male',
    isVerified: true,
    isAvailable: true,
    rating: 4.89,
    reviewsCount: 105,
    city: 'Bangalore',
    state: 'Karnataka',
    coverageCities: ['Bangalore', 'Mysore', 'Mangalore', 'Hyderabad'],
    hourlyRate: 1299,
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Tech entrepreneur, calm demeanor, great listener & perfect plus-one for family meets & casual outings.',
    about: 'Founder in the SaaS ecosystem living in Indiranagar, Bangalore. Deep passion for specialty coffee, board games, and great cuisine. I love meeting people from all walks of life with genuine respect and professionalism.',
    height: "5'11\"",
    languages: ['English', 'Hindi', 'Punjabi', 'Kannada (Basic)'],
    education: 'B.Tech in Computer Science (NIT Surathkal)',
    profession: 'Product Lead / Tech Founder',
    interests: ['Specialty Coffee', 'Startups', 'Board Games', 'Live Jazz', 'Road Trips'],
    supportedOccasions: ['Family Events', 'Fine Dining', 'Networking Mixers', 'Weekend Road Trips', 'Sports Events'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'meera-nair',
    name: 'Meera Nair',
    age: 24,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.94,
    reviewsCount: 104,
    city: 'Bangalore',
    state: 'Karnataka',
    coverageCities: ['Bangalore', 'Mysore', 'Kochi', 'Chennai'],
    hourlyRate: 1150,
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Creative UX designer, vibrant storyteller & enthusiastic companion for tech mixers & indie concerts.',
    about: 'Senior UX designer at a global design studio in Koramangala, Bangalore. A warm-hearted listener, fun conversationalist, and great company for craft brewery evenings, board game nights, and social meetups.',
    height: "5'5\"",
    languages: ['English', 'Malayalam', 'Hindi', 'Kannada'],
    education: 'B.Des (National Institute of Design)',
    profession: 'Senior UX Product Designer',
    interests: ['Craft Coffee', 'Indie Music Gigs', 'Trekking', 'Digital Art', 'Stand-up Comedy'],
    supportedOccasions: ['Tech Mixers', 'Indie Concerts', 'Casual Dinners', 'Weekend Getaways', 'Art Cafes'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },

  // ==================== TELANGANA (Hyderabad) ====================
  {
    id: 'vikramaditya-rao',
    name: 'Vikramaditya Rao',
    age: 26,
    gender: 'male',
    isVerified: true,
    isAvailable: true,
    rating: 4.92,
    reviewsCount: 96,
    city: 'Hyderabad',
    state: 'Telangana & AP',
    coverageCities: ['Hyderabad', 'Secunderabad', 'Warangal', 'Visakhapatnam', 'Bangalore'],
    hourlyRate: 1250,
    image: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Polite, cultured architect with great conversational depth. Ideal for heritage walks & royal weddings.',
    about: 'Architectural heritage consultant based in Banjara Hills, Hyderabad. Passionate about Nizam history, fine dining, photography and providing courteous, graceful companionship for your special days.',
    height: "5'11\"",
    languages: ['English', 'Telugu', 'Hindi', 'Urdu'],
    education: 'M.Arch (SPA Hyderabad)',
    profession: 'Heritage Architect & Urban Planner',
    interests: ['Heritage Architecture', 'Hyderabadi Fine Dining', 'Badminton', 'Classic Literature', 'Road Trips'],
    supportedOccasions: ['Royal Weddings', 'Heritage Walks', 'Art Exhibitions', 'Dinner Dates', 'Family Get-togethers'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },
  {
    id: 'fatima-zahra',
    name: 'Fatima Zahra',
    age: 24,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.95,
    reviewsCount: 114,
    city: 'Hyderabad',
    state: 'Telangana & AP',
    coverageCities: ['Hyderabad', 'Secunderabad', 'Warangal', 'Bangalore'],
    hourlyRate: 1199,
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Graceful, intellectual bio-tech researcher & wonderful conversationalist for Jubilee Hills fine dining.',
    about: 'Bio-tech research analyst living in Jubilee Hills, Hyderabad. Well-spoken, courteous, and enjoys poetry, heritage walks around Golconda, and attending elegant wedding receptions.',
    height: "5'4\"",
    languages: ['Urdu', 'Hindi', 'English', 'Telugu (Basic)'],
    education: 'M.S. in Biotechnology (Osmania University)',
    profession: 'Clinical Research Associate',
    interests: ['Hyderabadi Culinary History', 'Urdu Poetry & Ghazals', 'Art & Calligraphy', 'Heritage Walks', 'Badminton'],
    supportedOccasions: ['Nizami Weddings', 'Gourmet Dinners', 'Poetry Evenings', 'Family Meets', 'High Tea Dates'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },

  // ==================== RAJASTHAN (Jaipur) ====================
  {
    id: 'ananya-rathore',
    name: 'Ananya Rathore',
    age: 24,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.97,
    reviewsCount: 130,
    city: 'Jaipur',
    state: 'Rajasthan',
    coverageCities: ['Jaipur', 'Udaipur', 'Jodhpur', 'Delhi', 'Ajmer'],
    hourlyRate: 1200,
    image: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Royal heritage curator, jewelry designer & graceful companion for palace weddings and Amer Fort walks.',
    about: 'Jewelry design curator from C-Scheme, Jaipur. Born into a heritage Rajasthani family, I bring regal poise, deep knowledge of Rajasthani craft, and polite grace to destination palace weddings and heritage evenings.',
    height: "5'5\"",
    languages: ['Hindi', 'Rajasthani / Marwari', 'English'],
    education: 'B.Des in Jewelry Design (IICD Jaipur)',
    profession: 'Heritage Jewelry Designer',
    interests: ['Rajasthani Royal Heritage', 'Amer & Nahargarh Forts', 'Block Print Textiles', 'Classical Sitar', 'Equestrian Sports'],
    supportedOccasions: ['Palace Destination Weddings', 'Royal Banquets', 'Heritage Fort Walks', 'High Tea Dinners', 'Art Tours'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },

  // ==================== GOA ====================
  {
    id: 'alisha-fernandes',
    name: 'Alisha Fernandes',
    age: 24,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.95,
    reviewsCount: 112,
    city: 'Goa',
    state: 'Goa',
    coverageCities: ['Panaji', 'Margao', 'Calangute', 'Anjuna', 'Mumbai'],
    hourlyRate: 1250,
    image: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Marine ecologist, Latin dancer & charming companion for sunset beach dinners, jazz clubs & yacht trips.',
    about: 'Marine biology consultant and certified salsa dancer living in Panjim, Goa. Fluent in Portuguese, English, and Hindi. Vibrant, warm, and ensures your Goan vacation or beach wedding is magical, relaxed, and safe.',
    height: "5'5\"",
    languages: ['English', 'Konkani', 'Portuguese', 'Hindi'],
    education: 'M.Sc Marine Sciences (Goa University)',
    profession: 'Marine Conservation Consultant & Salsa Instructor',
    interests: ['Sunset Cruises', 'Latin Salsa & Bachata', 'Goan Heritage Architecture', 'Seafood Gastronomy', 'Scuba Diving'],
    supportedOccasions: ['Beach Weddings', 'Sunset Yacht Cruises', 'Live Jazz Nights', 'Heritage Fontainhas Walks', 'Romantic Beach Dinners'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },

  // ==================== UTTAR PRADESH (Lucknow) ====================
  {
    id: 'alizeh-mirza',
    name: 'Alizeh Mirza',
    age: 24,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.96,
    reviewsCount: 110,
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    coverageCities: ['Lucknow', 'Kanpur', 'Varanasi', 'Agra', 'Delhi'],
    hourlyRate: 1100,
    image: 'https://images.unsplash.com/photo-1571513722275-4b41940f54b8?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1571513722275-4b41940f54b8?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Chikankari curator, Urdu poetess & graceful plus-one for Hazratganj strolls, dastangoi & Awadhi feasts.',
    about: 'Heritage fashion curator and Urdu literature scholar based in Hazratganj, Lucknow. Known for unmatched tehzeeb (etiquette), lyrical conversational charm, and graceful poise at traditional wedding dinners.',
    height: "5'4\"",
    languages: ['Urdu', 'Hindi', 'English'],
    education: 'M.A. in Urdu Literature (Lucknow University)',
    profession: 'Heritage Chikankari Curator',
    interests: ['Tehzeeb & Urdu Dastangoi', 'Hazratganj Heritage Ganj-ing', 'Awadhi Dastarkhwan', 'Kathak Dance', 'Poetry Recitals'],
    supportedOccasions: ['Traditional Nikahs & Weddings', 'Awadhi Dinners', 'Ghazal & Dastangoi Evenings', 'Heritage Walks', 'Family Meets'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },

  // ==================== TAMIL NADU (Chennai) ====================
  {
    id: 'divya-subramanian',
    name: 'Divya Subramanian',
    age: 25,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.96,
    reviewsCount: 118,
    city: 'Chennai',
    state: 'Tamil Nadu',
    coverageCities: ['Chennai', 'Coimbatore', 'Madurai', 'Bangalore', 'Pondicherry'],
    hourlyRate: 1100,
    image: 'https://images.unsplash.com/photo-1609357605129-26f69add5d6e?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1609357605129-26f69add5d6e?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Carnatic violinist, architect & graceful companion for ECR cafe dates, Margazhi season & temple heritage.',
    about: 'Architectural researcher and classical Carnatic violinist living in Mylapore, Chennai. Well-versed in traditional South Indian heritage, Kanchipuram silk traditions, and beachside coffee conversations along ECR.',
    height: "5'4\"",
    languages: ['Tamil', 'English', 'Hindi'],
    education: 'B.Arch (Anna University, Chennai)',
    profession: 'Architectural Historian & Musician',
    interests: ['Carnatic Violin', 'Margazhi Music Season', 'Kanchipuram Silks', 'Filter Kaapi', 'Beachside Cafes'],
    supportedOccasions: ['South Indian Weddings', 'Classical Concerts', 'Heritage Temple Walks', 'ECR Cafe Dates', 'Family Dinners'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },

  // ==================== GUJARAT (Ahmedabad) ====================
  {
    id: 'janki-patel',
    name: 'Janki Patel',
    age: 24,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.95,
    reviewsCount: 106,
    city: 'Ahmedabad',
    state: 'Gujarat',
    coverageCities: ['Ahmedabad', 'Gandhinagar', 'Vadodara', 'Surat', 'Rajkot'],
    hourlyRate: 1100,
    image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Textile designer, heritage walk guide & sweet companion for Sabarmati Riverfront walks and Gujarati weddings.',
    about: 'NID Ahmedabad graduate and textile curator living on SG Highway, Ahmedabad. Polite, deeply respectful, and wonderful company for Garba nights, traditional Gujarati weddings, and riverfront heritage cafes.',
    height: "5'4\"",
    languages: ['Gujarati', 'Hindi', 'English'],
    education: 'B.Des in Textile Design (NID Ahmedabad)',
    profession: 'Textile Design Specialist',
    interests: ['Patola & Bandhani Weaves', 'Sabarmati Riverfront', 'Navratri Garba', 'Gujarati Gourmet Food', 'Pottery'],
    supportedOccasions: ['Gujarati Weddings', 'Garba Nights', 'Riverfront Strolls', 'Heritage Pol Walks', 'Family Dinners'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  },

  // ==================== PUNJAB & CHANDIGARH ====================
  {
    id: 'harpreet-gill',
    name: 'Harpreet Gill',
    age: 25,
    gender: 'female',
    isVerified: true,
    isAvailable: true,
    rating: 4.94,
    reviewsCount: 118,
    city: 'Chandigarh',
    state: 'Punjab & Chandigarh',
    coverageCities: ['Chandigarh', 'Ludhiana', 'Amritsar', 'Jalandhar', 'Delhi'],
    hourlyRate: 1150,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=800&q=80',
    ],
    bio: 'Vibrant RJ, fitness enthusiast & delightful companion for Sukhna Lake walks and Punjabi grand weddings.',
    about: 'Radio host and digital producer living in Sector 9, Chandigarh. Full of life, charming smile, courteous etiquette, and ready to make your wedding functions or evening outings joyous and memorable.',
    height: "5'7\"",
    languages: ['Punjabi', 'Hindi', 'English'],
    education: 'Master in Journalism (Panjab University, Chandigarh)',
    profession: 'Radio Jockey & Media Host',
    interests: ['Sukhna Lake Sunsets', 'Punjabi Folk Music', 'Sector 17 Cafes', 'Tennis', 'Fashion Styling'],
    supportedOccasions: ['Punjabi Weddings', 'Sangeet Nights', 'Sukhna Lake Walks', 'Fine Dining', 'Family Meets'],
    safetyVerified: {
      govtId: true,
      policeClearance: true,
      inPersonInterview: true,
    },
  }
];

export const CITIES_LIST = [
  'All Locations',
  'Kolkata, West Bengal',
  'Bardhaman, West Bengal',
  'Durgapur, West Bengal',
  'Siliguri, West Bengal',
  'Asansol, West Bengal',
  'Howrah, West Bengal',
  'Mumbai, Maharashtra',
  'Pune, Maharashtra',
  'Delhi, NCR',
  'Bangalore, Karnataka',
  'Hyderabad, Telangana',
  'Jaipur, Rajasthan',
  'Goa',
  'Ahmedabad, Gujarat',
  'Chandigarh, Punjab',
  'Lucknow, Uttar Pradesh'
];

export const OCCASIONS_LIST = [
  'All Occasions',
  'Tourist Guide',
  'Driver',
  'Movies',
  'Shopping',
  'Travel',
  'Medical Help',
  'Elder Care',
  'Domestic Help',
  'Business Events',
  'Outdoor Events',
  'Baking/Cooking',
  'Sporting Events',
  'Playing Sports',
  'Comedy Club',
  'Going to Bar',
  'Hanging Out',
  'Tutoring',
  'Clubbing',
  'Dinner',
  'Music',
  'Culture',
  'Parties',
  'Wedding & Reception',
  'Family Dinner / Meetup',
  'Formal Date & Dining',
  'Casual Coffee & Walk',
  'City Tour & Sightseeing',
  'Concert & Movie Night',
  'Corporate & Networking Event',
  'Travel & Weekend Trip'
];

// Pre-verified driver companion IDs
const VERIFIED_DRIVER_IDS = new Set([
  'abhik-roy-bardhaman',
  'sourav-chatterjee-howrah',
  'anirban-ghosh-durgapur',
  'rohit-das-siliguri',
  'kabir-mehra',
  'arjun-singhania',
  'aditya-verma',
  'kunal-kapoor'
]);

// Tourist guide companion IDs
const TOURIST_GUIDE_IDS = new Set([
  'riya-sharma',
  'priya-mukherjee-bardhaman',
  'debolina-sen-kolkata',
  'payel-banerjee-siliguri',
  'ananya-pandey',
  'meera-rajput',
  'tanya-kapoor',
  'amit-roy'
]);

// Canonical Demo Companion IDs & Booking Restriction Helpers (Master Directive Section 10 & 11)
export const DEMO_COMPANION_IDS = new Set<string>([
  ...COMPANIONS_DATA.map((c) => c.id),
  '1025',
  '1028',
  '1031',
  '1033',
  '1052',
  '1064',
  '1076',
  '1082',
  'comp-seed-01',
  'comp-seed-02',
  'comp-seed-03',
]);

export const DEMO_COMPANION_BOOKING_MESSAGES = {
  bn: 'এই Companion-টি বর্তমানে বাস্তব বুকিংয়ের জন্য উপলভ্য নয়। অনুগ্রহ করে অন্য একজন উপলভ্য Companion নির্বাচন করুন।',
  en: 'This Companion is not available for real bookings. Please choose another available Companion.',
  hi: 'यह Companion वर्तमान में वास्तविक बुकिंग के लिए उपलब्ध नहीं है। कृपया कोई अन्य उपलब्ध Companion चुनें।',
} as const;

export function getDemoCompanionBookingMessage(lang: 'en' | 'bn' | 'hi' = 'en'): string {
  return DEMO_COMPANION_BOOKING_MESSAGES[lang] || DEMO_COMPANION_BOOKING_MESSAGES.en;
}

export function isDemoCompanionProfile(
  candidate?:
    | string
    | null
    | {
        id?: string | null;
        companionId?: string | null;
        isDemo?: boolean | null;
        isSeed?: boolean | null;
        accountClassification?: string | null;
        email?: string | null;
      }
): boolean {
  if (!candidate) return false;
  if (typeof candidate === 'string') {
    const trimmed = candidate.trim();
    return Boolean(trimmed && DEMO_COMPANION_IDS.has(trimmed));
  }
  if (candidate.isDemo === true || candidate.isSeed === true) return true;
  if (String(candidate.accountClassification || '').toUpperCase() === 'DEMO') return true;
  if (candidate.id && DEMO_COMPANION_IDS.has(String(candidate.id).trim())) return true;
  if (candidate.companionId && DEMO_COMPANION_IDS.has(String(candidate.companionId).trim())) return true;
  if (typeof candidate.email === 'string' && candidate.email.trim().toLowerCase().endsWith('@example.com')) {
    return true;
  }
  return false;
}

export const DEMO_COMPANION_PHOTO_AUDIT_SUMMARY = {
  profilesReviewed: 29,
  primaryPhotosRetained: 29,
  conflictingGalleryReferencesRemoved: 58,
  storageFilesDeleted: 0,
  storageFilesQuarantined: 0,
  profilesFlaggedForReview: 0,
} as const;

// Enrich all companions with coordinates, package pricing, Demo classification, and single-photo gallery integrity
for (const comp of COMPANIONS_DATA) {
  comp.isDemo = true;
  comp.isVerified = false;
  comp.accountClassification = 'DEMO';
  comp.gallery = [comp.image];
  comp.safetyVerified = {
    govtId: false,
    policeClearance: false,
    inPersonInterview: false,
  };

  const coords = getCoordinatesForCity(comp.city);
  comp.latitude = coords.latitude;
  comp.longitude = coords.longitude;
  comp.location_details = {
    place_id: `place_${comp.city.toLowerCase().replace(/[^a-z0-9]/g, '_')}`,
    formatted_address: `${comp.city}, ${comp.state || 'India'}, India`,
    latitude: coords.latitude,
    longitude: coords.longitude,
    city: comp.city,
    state: comp.state || 'West Bengal',
    country: 'India',
    country_code: 'IN',
  };

  // Enforce minimum ₹600/hr policy
  comp.hourlyRate = Math.max(600, comp.hourlyRate || 600);

  // Set 1/3 Day, Half-Day, Full-Day package rates
  comp.rateOneThirdDay = comp.rateOneThirdDay || Math.max(2000, Math.round(comp.hourlyRate * 6 * 0.85));
  comp.rateHalfDay = comp.rateHalfDay || Math.max(3000, Math.round(comp.hourlyRate * 12 * 0.80));
  comp.rateFullDay = comp.rateFullDay || Math.max(5000, Math.round(comp.hourlyRate * 24 * 0.75));

  // Tourist Guide category integration
  if (TOURIST_GUIDE_IDS.has(comp.id)) {
    if (!comp.supportedOccasions.includes('Tourist Guide')) {
      comp.supportedOccasions.unshift('Tourist Guide');
    }
  }

  // Driver category & Driving Licence verification integration (no conflicting secondary image URLs)
  if (VERIFIED_DRIVER_IDS.has(comp.id)) {
    comp.drivingLicenceStatus = 'APPROVED';
    comp.isDriverApproved = true;
    comp.drivingLicenceDetails = {
      licenceNumber: `WB-02-DEMO-${comp.id.slice(0, 6).toUpperCase()}`,
      expiryDate: '2030-12-31',
      submittedAt: '2026-09-15T10:00:00.000Z',
      reviewedAt: '2026-09-16T14:30:00.000Z',
    };
    if (!comp.supportedOccasions.includes('Driver')) {
      comp.supportedOccasions.unshift('Driver');
    }
  } else {
    comp.drivingLicenceStatus = 'NOT_UPLOADED';
    comp.isDriverApproved = false;
  }
}

